var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.project)?_c('info-header-card',{attrs:{"icon":_vm.project.icon(),"header":_vm.card_header,"rows":_vm.card_rows}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }